import { NOTIFICATION_SLA_HOURS } from "./config";
import type { NotificationSeverity } from "./repo/notification-summary";

const SLA_TYPE_PREFIXES = ["wallet.topup", "wallet.kyc"];

export function isNotificationSlaStale(createdAt: Date | string): boolean {
  const at = typeof createdAt === "string" ? new Date(createdAt) : createdAt;
  const ageMs = Date.now() - at.getTime();
  return ageMs > NOTIFICATION_SLA_HOURS * 60 * 60 * 1000;
}

/** AN4 — topup/KYC ค้าง > SLA → แสดง severity warning (read-time) */
export function resolveEffectiveSeverity(
  type: string,
  stored: NotificationSeverity,
  createdAt: Date | string,
): NotificationSeverity {
  if (stored === "critical") return "critical";
  if (stored === "warning") return "warning";

  const slaType = SLA_TYPE_PREFIXES.some((prefix) => type.startsWith(prefix));
  if (slaType && isNotificationSlaStale(createdAt)) {
    return "warning";
  }

  return stored;
}
